import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { keys } from 'ramda';
import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import core from "../reducers";
import actionRegistry from "./actionRegistry";
import reducerRegistry from "./reducerRegistry";
import { createSimpleAction } from "../actions/actionCreators";
import { generateReducerForAction } from "./reducerGenerator";
var globalStore;
var isBrowser = typeof window !== 'undefined';
var defaultMiddlewares = [];
if (isBrowser && window.__REDUX_DEVTOOLS_EXTENSION__) {
  defaultMiddlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

/**
 * FIXME: dear god, please, rid us of this store
 * Snippet below is taken from adaptive
 */
export function getLegacyStore() {
  var _window$beeline;
  globalStore = globalStore || isBrowser && ((_window$beeline = window.beeline) === null || _window$beeline === void 0 ? void 0 : _window$beeline.store);
  if (!globalStore) {
    globalStore = createLegacyStore(defaultMiddlewares);
  }
  if (isBrowser) {
    window.beeline = window.beeline || {};
    window.beeline.store = window.beeline.store || globalStore;
  }
  return globalStore;
}
export var createLegacyStore = function createLegacyStore() {
  var middleware = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var composeEnhancer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : compose;
  var store = createStore(combineReducers({
    core: core,
    external: function external() {
      return {};
    }
  }), composeEnhancer.apply(void 0, [applyMiddleware(thunkMiddleware)].concat(_toConsumableArray(middleware))));
  store.addReducer = function (newReducer) {
    reducerRegistry.addReducer(newReducer);
    store.replaceReducer(combineReducers({
      core: core,
      external: reducerRegistry.getComposedReducer()
    }));
  };
  store.removeReducer = function (reducer) {
    reducerRegistry.removeReducer(reducer);
    store.replaceReducer(combineReducers({
      core: core,
      external: reducerRegistry.getComposedReducer()
    }));
  };
  store.createAction = function (options) {
    var action = createSimpleAction(options);
    actionRegistry.addActions(keys(action.types).reduce(function (result, type) {
      result["".concat(action.name, "_").concat(type)] = action.types[type];
      return result;
    }, {}));
    var reducer = generateReducerForAction(action);
    store.addReducer(reducer);
    store.dispatch({
      type: "".concat(action.name, "__initialize")
    });
    return action;
  };
  return store;
};

/**
 * @deprecated To keep backwards compatibility, just return the function
 */
export default createLegacyStore;